import { EvComboboxOption, OptionType } from '@evinced-private/ui-common';

import { FrequencyDto } from '../../interfaces/ScheduledJobConfiguration';

import { schedulingLabels } from './labels';

export const WEEKDAYS = [
	{ value: 7, label: 'Sunday', id: 'scheduling-sunday-checkbox' },
	{ value: 1, label: 'Monday', id: 'scheduling-monday-checkbox' },
	{ value: 2, label: 'Tuesday', id: 'scheduling-tuesday-checkbox' },
	{ value: 3, label: 'Wednesday', id: 'scheduling-wednesday-checkbox' },
	{ value: 4, label: 'Thursday', id: 'scheduling-thursday-checkbox' },
	{ value: 5, label: 'Friday', id: 'scheduling-friday-checkbox' },
	{ value: 6, label: 'Saturday', id: 'scheduling-saturday-checkbox' }
];

export const frequencyObject = {
	[FrequencyDto.MONTHLY]: Array.from({ length: 12 }, (_, i) => i + 1).map((month) => ({
		value: month,
		label: String(month)
	})),
	[FrequencyDto.WEEKLY]: Array.from({ length: 52 }, (_, i) => i + 1).map((week) => ({
		value: week,
		label: String(week)
	}))
};

export const frequencyOptions: EvComboboxOption[] = [
	{ value: FrequencyDto.MONTHLY, label: schedulingLabels.months },
	{ value: FrequencyDto.WEEKLY, label: schedulingLabels.weeks }
];
export const MONTH_OPTIONS: OptionType[] = [
	{ value: 1, label: 'January' },
	{ value: 2, label: 'February' },
	{ value: 3, label: 'March' },
	{ value: 4, label: 'April' },
	{ value: 5, label: 'May' },
	{ value: 6, label: 'June' },
	{ value: 7, label: 'July' },
	{ value: 8, label: 'August' },
	{ value: 9, label: 'September' },
	{ value: 10, label: 'October' },
	{ value: 11, label: 'November' },
	{ value: 12, label: 'December' }
];
